import React from 'react';
import { useNavigate } from "react-router-dom";
import Form from '/src/components/form/Form';
import CheckBox from '/src/components/UI/CheckBox/CheckBox';
import Field from '/src/components/UI/Field/Field';
import TextInput from '/src/components/UI/TextField/TextInput';
import TextArea from '/src/components/UI/TextField/TextArea';
import Dropdown from '../../../../components/UI/DropDown/DropDown';
import languages from '/src/data/dropdown/languages';
import Button from "/src/components/UI/Button/Button";
import { useForm } from 'react-hook-form';
import BotFormTypes from './BotFormTypes.js';
import botService from '../../services/botService'
import urlWithRoutingCompany from '/src/utils/urlWithRoutingCompany';
import "./BotForm.css"
function BotForm({ data, type }) {

	const navigate = useNavigate();
	const formData = BotFormTypes[type ? type : "create"];
	const regexNameBot = /^[a-zA-Z0-9À-ú-_ ]{3,}$/;
	formData.values = data;

	const { addBot, updateBot, isBotNameAvailable } = botService;

	const { register, setError, clearErrors, handleSubmit, watch, formState: { errors }, formState, setValue, getValues } = useForm({
		mode: "onChange",
		defaultValues: {
			name: formData.values ? formData.values.name : "",
			description: formData.values ? formData.values.description : "",
			language: formData.values ? formData.values.language.slug.toLowerCase() : "fr",
			save_data: formData.values ? formData.values.save_data : false,
			conversation_storage_time: formData.values ? (formData.values.conversation_storage_time > 0 ? 30 : 0) : 0
		}
	});

	const checkNameAvailability = async (name) => {
		if (data?.name === name) return true;

		let regex = new RegExp(regexNameBot)

		if (regex.test(name) == false) return

		var [response, errors] = await isBotNameAvailable(name)

		if (errors != null) {
			console.log(errors)
			return;
		}

		response = response.filter(bot => bot.name == name);
		if (response.length == 1) {
			setError("name", { type: 'focus', message: 'Oups this name is already taken' })
		}
		else {
			clearErrors("name")
			return true;
		}

	}
	const onSubmit = async () => {
		const dataToSend = getValues();
		let nameAvailable = await checkNameAvailability(dataToSend.name)

		if (nameAvailable != true) return;
		dataToSend.name = dataToSend.name.trim()
		dataToSend.name = dataToSend.name.replace(/\s+/g, ' '); // supprimer les espaces de plus d'un caractere
		const [response, errors] = type != null ? await updateBot(data.id, dataToSend) : await addBot(dataToSend);
		if (errors != null) {
			console.log(errors)
			return;
		}


		return type != null ? navigate(urlWithRoutingCompany('/bots/list')) : navigate(urlWithRoutingCompany(`/bots/${dataToSend.name}?fromCreated=${true}`));
	}
	return (
		<Form onSubmit={handleSubmit(onSubmit)} className="botForm-form">
			<Form.Title>{formData.title}</Form.Title>
			<Form.Body>
				<br />
				<div className="botForm-container">
					<Field label={<span>Name of bot<span className="obligatory_field">*</span> </span>} listLabelClassName="titles-input">
						<TextInput {...register('name', { required: true, pattern: regexNameBot, onChange: (e) => checkNameAvailability(e.target.value) })} style={errors.name ? { borderColor: "red" } : {}} />
						<span className='error'>{errors.name ? (errors.name.message ? errors.name.message : "At least 3 letters, and no specials character") : ""}</span>
					</Field>
				</div>
				<div className="botForm-container">
					<Field label="Enter a description" listLabelClassName="titles-input">
						<TextArea style={{ height: '40px' }} {...register('description')}></TextArea>
					</Field>
				</div>
				<div style={{ marginTop: "25px", display: "flex" }}>
					<Field label="Select your language" listLabelClassName="titles-input"></Field>
					<div style={{ marginLeft: "20%", marginTop: "2%" }}>
						<Dropdown  {...register('language')} setValue={setValue} choices={languages} defaultChoice={type == "update" ? formData.values.language.slug.toLowerCase() : "fr"} width="165px"></Dropdown>
					</div>
				</div>
				<br />
				<div title="Babar">
					<Field label={<span>🔁 Save the history of the conversation</span>} listLabelClassName="titles-input" listClassName={"flex switch_form_bot"}>
						<CheckBox name="Resume" onChange={() => setValue("conversation_storage_time", (getValues("conversation_storage_time") == 0 ? 30 : 0))} checked={getValues("conversation_storage_time")} />
					</Field>
					{/*
						<Field label={<span>💾 <abbr title="Backup of the variable" style={{ marginRight: "15px" }}> Save variable backup </abbr></span>} listLabelClassName="titles-input" listClassName={"flex switch_form_bot"}>
							<CheckBox name="Backup" onChange={() => setValue("save_data", !getValues("save_data"))} checked={getValues("save_data")} />
						</Field>
						*/
					}

				</div>


			</Form.Body>
			<br /><br /><br />
			<Form.Buttons>
				<Button type="submit" label={formData.send} className="validate" disabled={!formState.isValid} />
			</Form.Buttons>
		</Form >
	)

}

BotForm.defaultProps = {
	data: {},
	type: 'create'
}

export default BotForm;